import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-profile-edit',
  templateUrl: './ui-profile-edit.component.html',
  styleUrls: ['./ui-profile-edit.component.scss']
})
export class UiProfileEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
